import React from 'react';
import { Section } from './ui/Section';
import { Testimonial } from './Testimonial';
import { LemonSlice } from './botanical/LemonSlice';
export function Testimonials1() {
  return <Section className="bg-cream-warm relative overflow-hidden" data-id="element-391">
      <LemonSlice className="absolute top-10 -right-10 w-48 h-48 text-honey opacity-10 blur-sm" data-id="element-392" />

      <div className="text-center mb-10 relative z-10" data-id="element-393">
        <h2 className="text-sm font-bold tracking-widest text-moss uppercase" data-id="element-394">
          PRIMEROS TESTIMONIOS
        </h2>
      </div>
      <div className="grid md:grid-cols-3 gap-6 relative z-10" data-id="element-395">
        <Testimonial initials="MG" quote="Lo primero que hice fue el jarabe de cebolla para la tos de mi nena. En dos horas dejó de toser. No lo podía creer." author="María G." location="Córdoba" data-id="element-396" />
        <Testimonial initials="LP" quote="Mi marido se resfría seguido y siempre corría a la farmacia. Ahora tengo todo listo en casa. Cambió todo." author="Laura P." location="Rosario" data-id="element-397" />
        <Testimonial initials="RM" quote="El protocolo de digestión me salvó una noche que comí de más. Simple, rápido y funcionó." author="Roberto M." location="Buenos Aires" data-id="element-398" />
      </div>
    </Section>;
}